

const example_content = {
  hero_images: [],
  header: '',
  synopsis: '',
  paragraphs: [
    '',
    '',
    '',
  ],
}


export default {

  _key_arr: [
    28_02_2026, 20_04_2026
  ],

  28_02_2026 : {
    id: 1,
    title: "Sirens - Nuit Blanche @ Cultural Center Live",
    slug: "sirens-28-02-2026",
    content:   {
      hero_images: [],
      header: 'Sirens',
      sub_header: 'Sirens',
      synopsis: '',
      description_images: [],
      description_paragraphs: [
        '',
        '',
        '',
      ],
    },
  },

  20_04_2026 : {
    id: 2,
    title: "React Router Tips",
    slug: "react-router-tips",
    content:   {
      hero_images: [],
      header: '',
      sub_header: '',
      synopsis: '',
      description_images: [],
      description_paragraphs: [
        '',
        '',
        '',
      ],
    },
  },

}
  
  